import { tsValidateArray, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { Validator_ContextRule } from '../../_enum/context-rule/index.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    excludedVariableIds: tsValidateArray(tsValidateUniqueId),
    description: tsValidateString(undefined, false),
    rules: tsValidateArray(Validator_ContextRule)
};
const Validator_GeneratedProps = {
    _tagIds: tsValidateArray(tsValidateUniqueId)
};
export const DBDef_ContextRule = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'context-rule',
    entityName: 'context-rule',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'context-rule'
    },
    backend: {
        name: 'context-rule'
    },
    dependencies: {
        '_tagIds': { dbKey: 'tags', fieldType: 'string[]' },
        'excludedVariableIds': { dbKey: 'variables', fieldType: 'string[]' }
    }
};
//# sourceMappingURL=db-def.js.map